const Primary = 'Primary'
const Secondary = 'Secondary'

const BrandingColours = {
  [Primary]: '#1f2937', // gray-800
  [Secondary]: '#111827', // gray-900

}

export default BrandingColours